<template>
    <div>
        <div class="carousel-container half-width">
            <div class="jcarousel" ref="slideshow">
                <div class="slides">
                    <template v-for="(slide, i) in slides">
                        <figure :key="i" :id="`slide-${i}`" @click="handleClick(i)" class="slide-snapper">
                            <div class="img-container">
                                <img :src="url(slide.value.image)">
                                <div class="overlay">
                                    <div class="overlay-content">
                                        <IconMagnify />
                                    </div>
                                </div>
                            </div>
                            <figcaption v-if="slide.value.image.display_title || slide.value.image.caption">
                                <h3 v-if="slide.value.image.display_title">{{ slide.value.image.display_title }}</h3>
                                <p>{{ slide.value.image.caption }}</p>
                            </figcaption>
                        </figure>
                    </template>
                </div>
            </div>
            <div class="controls">
                <button class="jcarousel-prev">
                    <PrevIcon />
                </button>
                <button class="jcarousel-next">
                    <NextIcon />
                </button>
            </div>
        </div>
        <Modal v-show="isModalOpen" :is-open="isModalOpen" @close="isModalOpen = false">
            <template>
                <figure>
                    <div class="img">
                        <img :src="src" :alt="altText">
                    </div>
                    <figcaption v-if="caption || displayTitle" class="figca">
                        <h3 v-if="displayTitle" class="display-title">{{ displayTitle }}</h3>
                        <p v-if="caption" class="caption">{{ caption }}</p>
                    </figcaption>
                </figure>
                <div class="controls">
                    <PrevIcon @click="prevImage"/>
                    <NextIcon @click="nextImage"/>
                </div>
            </template>
        </Modal>
    </div>
</template>

<script>
import NextIcon from "@/assets/svg/slideshow-arrow-right.svg"
import PrevIcon from "@/assets/svg/slideshow-arrow-left.svg"
import Modal from "@/components/Modal"
import IconMagnify from "@/assets/svg/icon-gallery-hover.svg";

export default {
    name: 'CarouselBlock',
    props: {
        slides: Array
    },
    components: {
        NextIcon,
        PrevIcon,
        Modal,
        IconMagnify,
    },
    data() {
        return {
            currentSlideIndex: 0,
            isModalOpen: false,
            openImageIndex: 0,
        }
    },
    computed: {
        altText() {
            return this.slides[this.openImageIndex].value.image.alt_text || '';
        },
        src() {
            return this.url(this.slides[this.openImageIndex].value.image) || "#";
        },
        caption() {
            return this.slides[this.openImageIndex].value.image.caption || null;
        },
        displayTitle() {
            return this.slides[this.openImageIndex].value.image.display_title || null;
        }
    },
    methods: {
        url(image) {
            if (image.error) return '';
            return image.url;
        },
        nextImage() {
            this.openImageIndex = (this.openImageIndex + 1) % this.slides.length;
        },
        prevImage() {
            this.openImageIndex = (this.openImageIndex - 1 + this.slides.length) % this.slides.length;
        },
        handleClick(index) {
            console.log(index);
            this.openImageIndex = index;
            this.isModalOpen = true;
        },
        handleKeypress(event) {
            if (event.key === 'Escape') {
                this.isModalOpen = false;
            }
            else if (event.key === 'ArrowRight') {
                this.nextImage();
            }
            else if (event.key === 'ArrowLeft') {
                this.prevImage();
            }
        }
    },
    watch: {
        isModalOpen() {
            if (this.isModalOpen) {
                document.body.style.overflow = 'hidden';
                document.addEventListener('keyup', this.handleKeypress);
            } else {
                document.body.style.overflow = 'auto';
                document.removeEventListener('keyup', this.handleKeypress);
            }
        }
    },
    mounted() {
        // trigger carousel build in carousel.js
        const event = new Event("build", { bubbles: true });
        this.$refs.slideshow.dispatchEvent(event);
    }
}
</script>

<style lang="scss" scoped>
// in carousel.scss</style>
